import axios from "axios";

export const BOOK_URL = "/Book";

/** Belli Bir Kitap Listesini Elde Eder */
export function getBooks(queryParams) {
  return axios.post(`${BOOK_URL}/GetBooks`, queryParams);
}

/** Belli Bir Kitap Listesini Sayfalama Olmadan Elde Eder */
export function getAllBooks(queryParams) {
  return axios.post(`${BOOK_URL}/GetAllBooks`, queryParams);
}

/** Yeni Bir Kitap Elde Eder */
export function getNewBook() {
  return axios.get(BOOK_URL);
}

/** Belli Bir Kitabı Elde Eder */
export function getBook(id) {
  return axios.get(`${BOOK_URL}/${id}`);
}

/** Belli Bir Kitabı Kaydeder */
export function saveBook(branch) {
  return axios.post(BOOK_URL, branch);
}

/** Belli Bir Kitap Listesini Siler */
export function deleteBooks(ids) {
  return axios.post(`${BOOK_URL}/Delete`, { ids });
}